<table class="table table-bordered table-striped table-hover" id="excel-table">
  <thead class="thead-dark">
    <tr>
      <th translate class="header-float row-float-total row-table-head">
        {{'rmpv.analiseEstoque.titulo'}}
      </th>
      <th translate class="text-right header-float">
        {{'rmpv.analiseEstoque.meses.jan'}}
      </th>
      <th translate class="text-right header-float">
        {{'rmpv.analiseEstoque.meses.fev'}}
      </th>
      <th translate class="text-right header-float">
        {{'rmpv.analiseEstoque.meses.mar'}}
      </th>
      <th translate class="text-right header-float">
        {{'rmpv.analiseEstoque.meses.abr'}}
      </th>
      <th translate class="text-right header-float">
        {{'rmpv.analiseEstoque.meses.mai'}}
      </th>
      <th translate class="text-right header-float">
        {{'rmpv.analiseEstoque.meses.jun'}}
      </th>
      <th translate class="text-right header-float">
        {{'rmpv.analiseEstoque.meses.jul'}}
      </th>
      <th translate class="text-right header-float">
        {{'rmpv.analiseEstoque.meses.ago'}}
      </th>
      <th translate class="text-right header-float">
        {{'rmpv.analiseEstoque.meses.set'}}
      </th>
      <th translate class="text-right header-float">
        {{'rmpv.analiseEstoque.meses.out'}}
      </th>
      <th translate class="text-right header-float">
        {{'rmpv.analiseEstoque.meses.nov'}}
      </th>
      <th translate class="text-right header-float">
        {{'rmpv.analiseEstoque.meses.dez'}}
      </th>
      <th translate class="text-right header-float">
        Total
      </th>
      <th translate class="text-right header-float">
        % Total
      </th>
      <th translate class="text-right header-float">
        Total {{anoFiltro - 1}}
      </th>
      <th translate class="text-right header-float">
        Total {{anoFiltro - 2}}
      </th>
    </tr>
  </thead>
  <tbody>
    <!-- PREVISÃO COMPRA -->
    <tr *ngFor="let categoria of dados.previsao_compra.linhas">
      <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
      <td class="text-right">{{categoria.mes_01 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_02 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_03 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_04 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_05 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_06 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_07 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_08 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_09 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_10 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_11 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_12 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.total_ano | number:'1.2-2'}}</td>
      <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td>
      <td class="text-right">{{categoria.total_ano_anterior | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.total_ano_retrasado | number:'1.2-2'}}</td>
    </tr>
    <tr>
      <td translate class="dark-row row-float-total">{{'rmpv.analiseEstoque.previsaoCompraPCATotal'}}</td>
      <td class="text-right dark-row">{{dados.previsao_compra.total.mes_01 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.previsao_compra.total.mes_02 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.previsao_compra.total.mes_03 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.previsao_compra.total.mes_04 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.previsao_compra.total.mes_05 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.previsao_compra.total.mes_06 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.previsao_compra.total.mes_07 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.previsao_compra.total.mes_08 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.previsao_compra.total.mes_09 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.previsao_compra.total.mes_10 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.previsao_compra.total.mes_11 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.previsao_compra.total.mes_12 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.previsao_compra.total.total_ano | number:'1.2-2'}}</td>
      <td class="text-right dark-row percentual">{{dados.previsao_compra.total.percentual | percent: '1.1'}}</td>
      <td class="text-right dark-row">{{dados.previsao_compra.total.total_ano_anterior | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.previsao_compra.total.total_ano_retrasado | number:'1.2-2'}}</td>
    </tr>
    <!-- REALIZADO COMPRA -->
    <tr *ngFor="let categoria of dados.realizado_compra.linhas">
      <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
      <td class="text-right">{{categoria.mes_01 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_02 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_03 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_04 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_05 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_06 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_07 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_08 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_09 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_10 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_11 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_12 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.total_ano | number:'1.2-2'}}</td>
      <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td>
      <td class="text-right">{{categoria.total_ano_anterior | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.total_ano_retrasado | number:'1.2-2'}}</td>
    </tr>
    <tr>
      <td translate class="dark-row row-float-total">{{'rmpv.analiseEstoque.realizadoCompraPCATotal'}}</td>
      <td class="text-right dark-row">{{dados.realizado_compra.total.mes_01 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.realizado_compra.total.mes_02 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.realizado_compra.total.mes_03 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.realizado_compra.total.mes_04 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.realizado_compra.total.mes_05 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.realizado_compra.total.mes_06 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.realizado_compra.total.mes_07 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.realizado_compra.total.mes_08 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.realizado_compra.total.mes_09 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.realizado_compra.total.mes_10 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.realizado_compra.total.mes_11 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.realizado_compra.total.mes_12 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.realizado_compra.total.total_ano | number:'1.2-2'}}</td>
      <td class="text-right dark-row percentual">{{dados.realizado_compra.total.percentual | percent: '1.1'}}</td>
      <td class="text-right dark-row">{{dados.realizado_compra.total.total_ano_anterior | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.realizado_compra.total.total_ano_retrasado | number:'1.2-2'}}</td>
    </tr>
    <!-- % REALIZADO/PREVISAO COMPRA -->
    <tr>
      <td [translate]="getTranslate(dados.realizado_previsao_compras.descricao)" translate class="row-float"></td>
      <td class="text-right">{{dados.realizado_previsao_compras.mes_01 | number:'1.2-2'}}</td>
      <td class="text-right">{{dados.realizado_previsao_compras.mes_02 | number:'1.2-2'}}</td>
      <td class="text-right">{{dados.realizado_previsao_compras.mes_03 | number:'1.2-2'}}</td>
      <td class="text-right">{{dados.realizado_previsao_compras.mes_04 | number:'1.2-2'}}</td>
      <td class="text-right">{{dados.realizado_previsao_compras.mes_05 | number:'1.2-2'}}</td>
      <td class="text-right">{{dados.realizado_previsao_compras.mes_06 | number:'1.2-2'}}</td>
      <td class="text-right">{{dados.realizado_previsao_compras.mes_07 | number:'1.2-2'}}</td>
      <td class="text-right">{{dados.realizado_previsao_compras.mes_08 | number:'1.2-2'}}</td>
      <td class="text-right">{{dados.realizado_previsao_compras.mes_09 | number:'1.2-2'}}</td>
      <td class="text-right">{{dados.realizado_previsao_compras.mes_10 | number:'1.2-2'}}</td>
      <td class="text-right">{{dados.realizado_previsao_compras.mes_11 | number:'1.2-2'}}</td>
      <td class="text-right">{{dados.realizado_previsao_compras.mes_12 | number:'1.2-2'}}</td>
      <td class="text-right">{{dados.realizado_previsao_compras.total_ano | number:'1.2-2'}}</td>
      <td class="text-right percentual">{{dados.realizado_previsao_compras.percentual | percent: '1.1'}}</td>
      <td class="text-right">{{dados.realizado_previsao_compras.total_ano_anterior | number:'1.2-2'}}</td>
      <td class="text-right">{{dados.realizado_previsao_compras.total_ano_retrasado | number:'1.2-2'}}</td>
    </tr>
    <!-- ESTOQUE -->
    <tr *ngFor="let categoria of dados.estoque.linhas">
      <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
      <td class="text-right">{{categoria.mes_01 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_02 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_03 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_04 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_05 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_06 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_07 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_08 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_09 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_10 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_11 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_12 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.total_ano | number:'1.2-2'}}</td>
      <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td>
      <td class="text-right">{{categoria.total_ano_anterior | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.total_ano_retrasado | number:'1.2-2'}}</td>
    </tr>
    <tr>
      <td translate class="dark-row row-float-total">{{'rmpv.analiseEstoque.estoquePCATotal'}}</td>
      <td class="text-right dark-row">{{dados.estoque.total.mes_01 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.estoque.total.mes_02 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.estoque.total.mes_03 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.estoque.total.mes_04 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.estoque.total.mes_05 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.estoque.total.mes_06 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.estoque.total.mes_07 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.estoque.total.mes_08 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.estoque.total.mes_09 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.estoque.total.mes_10 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.estoque.total.mes_11 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.estoque.total.mes_12 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.estoque.total.total_ano | number:'1.2-2'}}</td>
      <td class="text-right dark-row percentual">{{dados.estoque.total.percentual | percent: '1.1'}}</td>
      <td class="text-right dark-row">{{dados.estoque.total.total_ano_anterior | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.estoque.total.total_ano_retrasado | number:'1.2-2'}}</td>
    </tr>
    <!-- ESTOQUE SEM ROTATIVIDADE-->
    <tr *ngFor="let categoria of dados.estoque_sem_rotatividade.linhas">
      <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
      <td class="text-right">{{categoria.mes_01 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_02 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_03 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_04 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_05 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_06 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_07 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_08 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_09 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_10 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_11 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.mes_12 | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.total_ano | number:'1.2-2'}}</td>
      <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td>
      <td class="text-right">{{categoria.total_ano_anterior | number:'1.2-2'}}</td>
      <td class="text-right">{{categoria.total_ano_retrasado | number:'1.2-2'}}</td>
    </tr>
    <tr>
      <td translate class="dark-row row-float-total">{{'rmpv.analiseEstoque.Estoque12PCATotal'}}</td>
      <td class="text-right dark-row">{{dados.estoque_sem_rotatividade.total.mes_01 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.estoque_sem_rotatividade.total.mes_02 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.estoque_sem_rotatividade.total.mes_03 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.estoque_sem_rotatividade.total.mes_04 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.estoque_sem_rotatividade.total.mes_05 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.estoque_sem_rotatividade.total.mes_06 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.estoque_sem_rotatividade.total.mes_07 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.estoque_sem_rotatividade.total.mes_08 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.estoque_sem_rotatividade.total.mes_09 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.estoque_sem_rotatividade.total.mes_10 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.estoque_sem_rotatividade.total.mes_11 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.estoque_sem_rotatividade.total.mes_12 | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.estoque_sem_rotatividade.total.total_ano | number:'1.2-2'}}</td>
      <td class="text-right dark-row percentual">{{dados.estoque_sem_rotatividade.total.percentual | percent: '1.1'}}
      </td>
      <td class="text-right dark-row">{{dados.estoque_sem_rotatividade.total.total_ano_anterior | number:'1.2-2'}}</td>
      <td class="text-right dark-row">{{dados.estoque_sem_rotatividade.total.total_ano_retrasado | number:'1.2-2'}}</td>
    </tr>
    <!-- % ESTOQUE BAIXO GIRO -->
    <tr>
      <td [translate]="getTranslate(dados.percentual_estoque_baixo_giro.descricao)" class="row-float"></td>
      <td class="text-right">{{dados.percentual_estoque_baixo_giro.mes_01 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_estoque_baixo_giro.mes_02 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_estoque_baixo_giro.mes_03 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_estoque_baixo_giro.mes_04 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_estoque_baixo_giro.mes_05 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_estoque_baixo_giro.mes_06 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_estoque_baixo_giro.mes_07 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_estoque_baixo_giro.mes_08 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_estoque_baixo_giro.mes_09 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_estoque_baixo_giro.mes_10 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_estoque_baixo_giro.mes_11 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_estoque_baixo_giro.mes_12 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_estoque_baixo_giro.total_ano | percent:'1.1-1'}}</td>
      <td class="text-right percentual">{{dados.percentual_estoque_baixo_giro.percentual | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_estoque_baixo_giro.total_ano_anterior | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_estoque_baixo_giro.total_ano_retrasado | percent:'1.1-1'}}</td>
    </tr>
    <!-- GIRO DE ESTOQUE PECAS -->
    <tr>
      <td [translate]="getTranslate(dados.percentual_giro_peca.descricao)" class="row-float"></td>
      <td class="text-right">{{dados.percentual_giro_peca.mes_01 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_peca.mes_02 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_peca.mes_03 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_peca.mes_04 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_peca.mes_05 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_peca.mes_06 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_peca.mes_07 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_peca.mes_08 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_peca.mes_09 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_peca.mes_10 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_peca.mes_11 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_peca.mes_12 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_peca.total_ano | percent:'1.1-1'}}</td>
      <td class="text-right percentual">{{dados.percentual_giro_peca.percentual | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_peca.total_ano_anterior | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_peca.total_ano_retrasado | percent:'1.1-1'}}</td>
    </tr>
    <!-- GIRO DE ESTOQUE ACESSORIOS -->
    <tr>
      <td translate class="row-float">{{'rmpv.analiseEstoque.giroEstoqueAcessorios'}}</td>
      <td class="text-right">{{dados.percentual_giro_acessorio.mes_01 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_acessorio.mes_02 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_acessorio.mes_03 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_acessorio.mes_04 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_acessorio.mes_05 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_acessorio.mes_06 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_acessorio.mes_07 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_acessorio.mes_08 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_acessorio.mes_09 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_acessorio.mes_10 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_acessorio.mes_11 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_acessorio.mes_12 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_acessorio.total_ano | percent:'1.1-1'}}</td>
      <td class="text-right percentual">{{dados.percentual_giro_acessorio.percentual | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_acessorio.total_ano_anterior | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_acessorio.total_ano_retrasado | percent:'1.1-1'}}</td>
    </tr>
    <!-- GIRO DE ESTOQUE CLOTHING -->
    <tr>
      <td [translate]="getTranslate(dados.percentual_giro_clothing.descricao)" class="row-float"></td>
      <td class="text-right">{{dados.percentual_giro_clothing.mes_01 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_clothing.mes_02 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_clothing.mes_03 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_clothing.mes_04 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_clothing.mes_05 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_clothing.mes_06 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_clothing.mes_07 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_clothing.mes_08 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_clothing.mes_09 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_clothing.mes_10 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_clothing.mes_11 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_clothing.mes_12 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_clothing.total_ano | percent:'1.1-1'}}</td>
      <td class="text-right percentual">{{dados.percentual_giro_clothing.percentual | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_clothing.total_ano_anterior | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_clothing.total_ano_retrasado | percent:'1.1-1'}}</td>
    </tr>
    <!-- GIRO DE ESTOQUE PCA TOTAL -->
    <tr>
      <td translate class="row-float">{{'rmpv.analiseEstoque.giroEstoquePCATotal'}}</td>
      <td class="text-right">{{dados.percentual_giro_pca_total.mes_01 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_pca_total.mes_02 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_pca_total.mes_03 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_pca_total.mes_04 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_pca_total.mes_05 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_pca_total.mes_06 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_pca_total.mes_07 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_pca_total.mes_08 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_pca_total.mes_09 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_pca_total.mes_10 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_pca_total.mes_11 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_pca_total.mes_12 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_pca_total.total_ano | percent:'1.1-1'}}</td>
      <td class="text-right percentual">{{dados.percentual_giro_pca_total.percentual | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_pca_total.total_ano_anterior | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_giro_pca_total.total_ano_retrasado | percent:'1.1-1'}}</td>
    </tr>
    <!-- PECA ATENDIDA-->
    <tr *ngFor="let categoria of dados.peca_atendida.linhas">
      <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
      <td class="text-right">{{categoria.mes_01}}</td>
      <td class="text-right">{{categoria.mes_02}}</td>
      <td class="text-right">{{categoria.mes_03}}</td>
      <td class="text-right">{{categoria.mes_04}}</td>
      <td class="text-right">{{categoria.mes_05}}</td>
      <td class="text-right">{{categoria.mes_06}}</td>
      <td class="text-right">{{categoria.mes_07}}</td>
      <td class="text-right">{{categoria.mes_08}}</td>
      <td class="text-right">{{categoria.mes_09}}</td>
      <td class="text-right">{{categoria.mes_10}}</td>
      <td class="text-right">{{categoria.mes_11}}</td>
      <td class="text-right">{{categoria.mes_12}}</td>
      <td class="text-right">{{categoria.total_ano}}</td>
      <td class="text-right percentual">{{categoria.percentual | percent:'1.1-1'}}</td>
      <td class="text-right">{{categoria.total_ano_anterior}}</td>
      <td class="text-right">{{categoria.total_ano_retrasado}}</td>
    </tr>
    <!-- PECA SOLICITADA-->
    <tr *ngFor="let categoria of dados.peca_solicitada.linhas">
      <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
      <td class="text-right">{{categoria.mes_01}}</td>
      <td class="text-right">{{categoria.mes_02}}</td>
      <td class="text-right">{{categoria.mes_03}}</td>
      <td class="text-right">{{categoria.mes_04}}</td>
      <td class="text-right">{{categoria.mes_05}}</td>
      <td class="text-right">{{categoria.mes_06}}</td>
      <td class="text-right">{{categoria.mes_07}}</td>
      <td class="text-right">{{categoria.mes_08}}</td>
      <td class="text-right">{{categoria.mes_09}}</td>
      <td class="text-right">{{categoria.mes_10}}</td>
      <td class="text-right">{{categoria.mes_11}}</td>
      <td class="text-right">{{categoria.mes_12}}</td>
      <td class="text-right">{{categoria.total_ano}}</td>
      <td class="text-right percentual">{{categoria.percentual | percent:'1.1-1'}}</td>
      <td class="text-right">{{categoria.total_ano_anterior}}</td>
      <td class="text-right">{{categoria.total_ano_retrasado}}</td>
    </tr>
    <!-- % DISPONIBILIDADE IMEDIATA PEÇAS -->
    <tr>
      <td [translate]="getTranslate(dados.percentual_disponibilidade_pecas.descricao)" class="row-float"></td>
      <td class="text-right">{{dados.percentual_disponibilidade_pecas.mes_01 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_disponibilidade_pecas.mes_02 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_disponibilidade_pecas.mes_03 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_disponibilidade_pecas.mes_04 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_disponibilidade_pecas.mes_05 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_disponibilidade_pecas.mes_06 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_disponibilidade_pecas.mes_07 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_disponibilidade_pecas.mes_08 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_disponibilidade_pecas.mes_09 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_disponibilidade_pecas.mes_10 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_disponibilidade_pecas.mes_11 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_disponibilidade_pecas.mes_12 | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_disponibilidade_pecas.total_ano | percent:'1.1-1'}}</td>
      <td class="text-right percentual">{{dados.percentual_disponibilidade_pecas.percentual | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_disponibilidade_pecas.total_ano_anterior | percent:'1.1-1'}}</td>
      <td class="text-right">{{dados.percentual_disponibilidade_pecas.total_ano_retrasado | percent:'1.1-1'}}</td>
    </tr>
    <tr>
      <td>...</td>
      <td>...</td>
      <td>...</td>
      <td>...</td>
      <td>...</td>
      <td>...</td>
      <td>...</td>
      <td>...</td>
      <td>...</td>
      <td>...</td>
      <td>...</td>
      <td>...</td>
      <td>...</td>
      <td>...</td>
      <td>...</td>
      <td>...</td>
      <td>...</td>
    </tr>
    <tr>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
    </tr>
  </tbody>
</table>
